export default "__VITE_ASSET__Dm97U5M1__"